//#region Angular Imports

import { StateService } from '@uirouter/angularjs'

//#endregion

//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import 'devextreme/ui/load_indicator'
import 'devextreme/ui/tooltip'

//#endregion

import { Api, LocalDictionaryFactory } from '../../api/api.module'

import { IUserSession } from '../../../helpers/user-session'
import { SYSTEM_SERVICE_NAME, SystemService } from '../../../services/system'
import { GridContextMenuService, GRID_CONTEXT_MENU_SERVICE_NAME } from '../../../services/grid'

import { TableController } from './table.controller'

//#region Asset Imports

import './table.scss'
import * as TEMPLATE from './table.tpl.html'

//#endregion

export class TableDirective implements ng.IDirective {
    scope = {
        data: '=',
        fitToScreen: '=?',
        isEditMode: '='
    }

    restrict = 'E'
    controller = [
        '$scope',
        '$q',
        '$timeout',
        '$state',
        'api',
        'localDictionary',
        'userSession',
        GRID_CONTEXT_MENU_SERVICE_NAME,
        SYSTEM_SERVICE_NAME,
        (
            $scope,
            $q: ng.IQService,
            $timeout: ng.ITimeoutService,
            $state: StateService,
            api: Api,
            localDictionary: LocalDictionaryFactory,
            userSession: IUserSession,
            gridContextMenuService: GridContextMenuService,
            systemService: SystemService
        ) => new TableController($scope, $q, $timeout, $state, api, localDictionary, gridContextMenuService, userSession, systemService)

    ]

    template = TEMPLATE
    transclude = true
    replace = true
}